import { TYPES } from '../types';
import { http } from '@/http'
import { _buildQuery } from '@/utils/Index';

const state = {
    customers: [],
    meta: {},
    current_url: ''
}
export default {
    namespaced: true,
    state: state,

    mutations: {
        [TYPES.mutations.CUSTOMERS_DATA](state, { data, url }) {
            state.customers = data.data;
            state.meta = data.meta
            state.current_url = url
        },
        [TYPES.mutations.REST_CUSTOMER_DATA](state) {
            state.customers = [];
            state.meta = {};
        },
        [TYPES.mutations.REMOVE_MCP_CUSTOMER](state, customer) {
            const index = state.customers.indexOf(customer);
            state.customers.splice(index, 1);
        },
    },
    getters: {
        [TYPES.getters.GET_CUSTOMERS](state) {
            return state.customers;
        },
        [TYPES.getters.GET_CUSTOMERS_META](state) {
            return state.meta;
        },
    },
    actions: {
        [TYPES.actions.GET_CUSTOMERS]({ commit }, { url, data }) {
            return new Promise((resolve, reject) => {
                http.setHeader();
                http.request().get(`${url}` + _buildQuery(data)).then((res) => {
                    commit(TYPES.mutations.CUSTOMERS_DATA, { data: res.data, url: url });
                    resolve(true);
                }).catch((error) => {
                    reject(error);
                })
            })
        },

        [TYPES.actions.ADD_CUSTOMERS]({ }, payload) {
            return new Promise((resolve, reject) => {
                http.setHeader();
                http.request().post('customers/create', payload).then((res) => {
                    resolve(res.data)
                }).catch((error) => {
                    reject(error);
                })
            })
        },

        [TYPES.actions.EDIT_CUSTOMERS]({ }, payload) {
            return new Promise((resolve, reject) => {
                http.setHeader();
                http.request().post('customers/update', payload).then((res) => {
                    resolve(res.data)
                }).catch((error) => {
                    reject(error);
                })
            })
        },

        [TYPES.actions.REMOVE_MCP_CUSTOMER]({ commit }, payload) {
            return new Promise((resolve, reject) => {
                http.setHeader();
                http.request().post('customers/mcp/delete', { id: payload.id }).then((res) => {
                    commit(TYPES.mutations.REMOVE_MCP_CUSTOMER, payload);
                    resolve(res.data)
                }).catch((error) => {
                    reject(error);
                })
            })
        },
    }
}
